import { connect } from 'react-redux';
import { GuaranteedInheritanceComponent } from './../../components/GuaranteedInheritance/GuaranteedInheritanceComponent';

const mapStateToProps = state => (state);
const mapDispatchToProps = dispatch => ({
  onChangeInput: (field, value) => {
    dispatch({ type: 'UPDATE_INPUT', payload: { field, value } });
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(GuaranteedInheritanceComponent);



// WEBPACK FOOTER //
// ./src/containers/GuaranteedInheritance/GuaranteedInheritance.js